/**
 * Locale de formato (fechas y números) según el idioma de la UI. Auditoría
 * 18/09/2026: `'es-AR'` estaba hardcodeado 45 veces en toLocaleDateString /
 * toLocaleString / Intl.DateTimeFormat, así que quien usa el BO en inglés o
 * portugués veía "18 sept 2026" y "1.234,5" igual. Dos mapas locales
 * (pnl-format, PeopleLandingPage) ya hacían esto bien; ahora es uno.
 *
 * Los locales de VOZ (SpeechRecognition / Polly) NO son esto: viven en
 * lib/speech-utils.ts y siguen siendo 'es-AR' porque es el acento, no el formato.
 */
import { useTranslation } from 'react-i18next';
import i18n from '@/i18n/i18n';

export const LOCALES: Record<string, string> = { es: 'es-AR', en: 'en-US', pt: 'pt-BR' };

/** 'es' | 'en' | 'pt' (o lo que haya) → BCP-47 de formato. */
export function localeFor(lang: string | undefined | null): string {
  return LOCALES[(lang ?? 'es').slice(0, 2)] ?? LOCALES.es;
}

/** Fuera de componentes (helpers de módulo): el locale del idioma actual de la UI. */
export function currentLocale(): string {
  return localeFor(i18n.language);
}

/** Dentro de componentes: se re-renderiza al cambiar el idioma. */
export function useLocale(): string {
  const { i18n: inst } = useTranslation();
  return localeFor(inst.language);
}
